export class InspectionSession
{
    SectionId: string;
    SectionName: string;
    SectionChecked: boolean  
}
